import React from 'react';
import styled from 'styled-components';
import { setBreakdownGroupBinning } from '../../../../../../redux/slices/oldBuilder';
import SwitchiOS from '../../../../../SwitchiOS';
import { useAppDispatch } from '../../../../../../redux/hooks';
import { IEnumBinning } from '../../../../../../redux/slices/oldBuilder/binning/types';
import produce from 'immer';
import InformationalTooltip from '../../../../../InformationalTooltip';
import * as BuilderUI from '../../../../BuilderUI';

interface IProps {
  binning: IEnumBinning;
  groupIndex: number;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
  max-width: 184px;
  margin-top: 12px;
  margin-left: 24px;
`;

const StyledSwitchiOS = styled(SwitchiOS)`
  margin-left: auto;
`;

/**
 * Simple Switch for Group Others control in breakdown-Enum Binning
 */
export default ({ binning, groupIndex }: IProps) => {
  const dispatch = useAppDispatch();
  const handleSwitch = () => {
    const newBinning = produce(binning, (newBinning) => {
      newBinning.enumBucketSplitOthers = !binning.enumBucketSplitOthers;
      delete newBinning.namedBucketDef;
    });

    dispatch(
      setBreakdownGroupBinning({
        groupIndex,
        newBinning,
      }),
    );
  };

  return (
    <Container>
      <BuilderUI.InputLabel>Group Others</BuilderUI.InputLabel>
      <InformationalTooltip
        tooltipOption={{
          content: 'If enabled, all other values will be grouped together.',
        }}
        size={14}
      />
      <StyledSwitchiOS
        // kobol naming it as splitOthers, but on UI, it's called group others.
        // therefore it's opposite result.
        isChecked={!binning.enumBucketSplitOthers}
        onClick={handleSwitch}
      />
    </Container>
  );
};
